import { CustomerInterface } from "./customer.interface";
import { LineItem } from "./lineitem.interface";
import { PDFInterface } from "./pdf.interface";

interface InvoiceInterface {
    type: string;
    customer: CustomerInterface | null;
    number: number;
    custom: string;
    dateCreated: Date;
    dateDue: Date;
    subTotal: number;
    total: number;
    gst: number;
    isGSTIncluded: boolean;
    lineItems: LineItem[];
    amountDue?: number;
    status?: InvoiceStatus;
    /** Calculated by the server for invoice list responses. */
    isReconciled?: boolean;
    paymentsMade: PaymentInterface[];
    pdf: PDFInterface;
    communicationLog: CommunicationLog[];
    additionalData?: any;
  }

interface PaymentInterface {
  amount: number;
  date: Date;
  method: string;
  note: string;
  paymentId?: string;
  transactionSha1?: string | null;
}

interface CommunicationLog {
  method: string;
  date: string;
  jobID: string;
}

interface MSPInvoiceInterface extends InvoiceInterface {
  MCRLineItems: LineItem[];
  serviceLineItems: LineItem[];
  period: string;
  currentBalance: number;
}

interface TaskInvoiceInterface extends InvoiceInterface {
  taskID: number;
}

enum InvoiceStatus {
  Unpaid = "unpaid",
  Paid = "paid",
  Refund = "refund"
}

export { TaskInvoiceInterface, InvoiceInterface, MSPInvoiceInterface, PaymentInterface, InvoiceStatus }
